export default __webpack_public_path__ + "static/media/logo10.9b99a8ea.svg";